import type { IntlShape } from 'react-intl';
import { FaqFilterType } from '../types';

export const getParkAggregatesQuestionStrings = (intl: IntlShape, locationName: string, filter?: FaqFilterType) => {
  const messageKey = filter || 'default';

  const translations = {
    default: intl.formatMessage(
      {
        defaultMessage: 'How many trails are in {locationName}?'
      },
      { locationName }
    ),
    backpacking: intl.formatMessage(
      {
        defaultMessage: 'How many backpacking trails are in {locationName}?'
      },
      { locationName }
    ),
    'bike-touring': intl.formatMessage(
      {
        defaultMessage: 'How many bike touring trails are in {locationName}?'
      },
      { locationName }
    ),
    birding: intl.formatMessage(
      {
        defaultMessage: 'How many birding trails are in {locationName}?'
      },
      { locationName }
    ),
    camping: intl.formatMessage(
      {
        defaultMessage: 'How many camping trails are in {locationName}?'
      },
      { locationName }
    ),
    fishing: intl.formatMessage(
      {
        defaultMessage: 'How many fishing trails are in {locationName}?'
      },
      { locationName }
    ),
    hiking: intl.formatMessage(
      {
        defaultMessage: 'How many hiking trails are in {locationName}?'
      },
      { locationName }
    ),
    'horseback-riding': intl.formatMessage(
      {
        defaultMessage: 'How many horseback riding trails are in {locationName}?'
      },
      { locationName }
    ),
    'mountain-biking': intl.formatMessage(
      {
        defaultMessage: 'How many mountain biking trails are in {locationName}?'
      },
      { locationName }
    ),
    'off-road-driving': intl.formatMessage(
      {
        defaultMessage: 'How many off-road driving trails are in {locationName}?'
      },
      { locationName }
    ),
    'road-biking': intl.formatMessage(
      {
        defaultMessage: 'How many road biking trails are in {locationName}?'
      },
      { locationName }
    ),
    'rock-climbing': intl.formatMessage(
      {
        defaultMessage: 'How many rock climbing trails are in {locationName}?'
      },
      { locationName }
    ),
    'scenic-driving': intl.formatMessage(
      {
        defaultMessage: 'How many scenic driving trails are in {locationName}?'
      },
      { locationName }
    ),
    skiing: intl.formatMessage(
      {
        defaultMessage: 'How many skiing trails are in {locationName}?'
      },
      { locationName }
    ),
    snowshoeing: intl.formatMessage(
      {
        defaultMessage: 'How many snowshoeing trails are in {locationName}?'
      },
      { locationName }
    ),
    'trail-running': intl.formatMessage(
      {
        defaultMessage: 'How many running trails are in {locationName}?'
      },
      { locationName }
    ),
    'via-ferrata': intl.formatMessage(
      {
        defaultMessage: 'How many via ferrata trails are in {locationName}?'
      },
      { locationName }
    ),
    walking: intl.formatMessage(
      {
        defaultMessage: 'How many walking trails are in {locationName}?'
      },
      { locationName }
    ),
    'cross-country-skiing': intl.formatMessage(
      {
        defaultMessage: 'How many cross-country skiing trails are in {locationName}?'
      },
      { locationName }
    ),
    ada: intl.formatMessage(
      {
        defaultMessage: 'How many wheelchair-friendly trails are in {locationName}?'
      },
      { locationName }
    ),
    beach: intl.formatMessage(
      {
        defaultMessage: 'How many beach trails are in {locationName}?'
      },
      { locationName }
    ),
    cave: intl.formatMessage(
      {
        defaultMessage: 'How many cave trails are in {locationName}?'
      },
      { locationName }
    ),
    'city-walk': intl.formatMessage(
      {
        defaultMessage: 'How many city walk trails are in {locationName}?'
      },
      { locationName }
    ),
    dogs: intl.formatMessage(
      {
        defaultMessage: 'How many dog-friendly trails are in {locationName}?'
      },
      { locationName }
    ),
    forest: intl.formatMessage(
      {
        defaultMessage: 'How many forest trails are in {locationName}?'
      },
      { locationName }
    ),
    'historic-site': intl.formatMessage(
      {
        defaultMessage: 'How many historic site trails are in {locationName}?'
      },
      { locationName }
    ),
    'hot-springs': intl.formatMessage(
      {
        defaultMessage: 'How many trails with hot springs are in {locationName}?'
      },
      { locationName }
    ),
    kids: intl.formatMessage(
      {
        defaultMessage: 'How many kid-friendly trails are in {locationName}?'
      },
      { locationName }
    ),
    lake: intl.formatMessage(
      {
        defaultMessage: 'How many lake trails are in {locationName}?'
      },
      { locationName }
    ),
    'partially-paved': intl.formatMessage(
      {
        defaultMessage: 'How many partially paved trails are in {locationName}?'
      },
      { locationName }
    ),
    paved: intl.formatMessage(
      {
        defaultMessage: 'How many paved trails are in {locationName}?'
      },
      { locationName }
    ),
    'pub-crawl': intl.formatMessage(
      {
        defaultMessage: 'How many pub walks are in {locationName}?'
      },
      { locationName }
    ),
    'rails-trails': intl.formatMessage(
      {
        defaultMessage: 'How many rail trails are in {locationName}?'
      },
      { locationName }
    ),
    river: intl.formatMessage(
      {
        defaultMessage: 'How many river trails are in {locationName}?'
      },
      { locationName }
    ),
    strollers: intl.formatMessage(
      {
        defaultMessage: 'How many stroller-friendly trails are in {locationName}?'
      },
      { locationName }
    ),
    waterfall: intl.formatMessage(
      {
        defaultMessage: 'How many waterfall trails are in {locationName}?'
      },
      { locationName }
    ),
    wildlife: intl.formatMessage(
      {
        defaultMessage: 'How many wildlife trails are in {locationName}?'
      },
      { locationName }
    )
  };

  return translations[messageKey];
};

type ParkAggregatesAnswerWithFilterProps = {
  filter: FaqFilterType;
  locationName: string;
  trailCount: string;
  rating: string;
  reviewCount: string;
  intl: IntlShape;
};
export const ParkAggregatesAnswerWithFilter = ({
  filter,
  locationName,
  trailCount,
  rating,
  reviewCount,
  intl
}: ParkAggregatesAnswerWithFilterProps) => {
  const messageKey = filter || 'default';
  const parkName = locationName;

  const trailCountInLocationTranslation = {
    default: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one trail} other {are # trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    backpacking: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one backpacking trail} other {are # backpacking trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'bike-touring': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one bike touring trail} other {are # bike touring trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    birding: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one birding trail} other {are # birding trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    camping: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one camping trail} other {are # camping trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    fishing: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one fishing trail} other {are # fishing trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    hiking: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one hiking trail} other {are # hiking trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'horseback-riding': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one horseback riding trail} other {are # horseback riding trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'mountain-biking': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one mountain biking trail} other {are # mountain biking trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'off-road-driving': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one off-road driving trail} other {are # off-road driving trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'road-biking': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one road biking trail} other {are # road biking trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'rock-climbing': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one rock climbing trail} other {are # rock climbing trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'scenic-driving': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one scenic driving trail} other {are # scenic driving trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    skiing: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one skiing trail} other {are # skiing trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    snowshoeing: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one snowshoeing trail} other {are # snowshoeing trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'trail-running': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one running trail} other {are # running trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'via-ferrata': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one via ferrata trail} other {are # via ferrata trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    walking: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one walking trail} other {are # walking trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'cross-country-skiing': intl.formatMessage(
      {
        defaultMessage:
          'There {trailCount, plural, one {is one cross-country skiing trail} other {are # cross-country skiing trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    ada: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one wheelchair-friendly trail} other {are # wheelchair-friendly trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    beach: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one beach trail} other {are # beach trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    cave: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one cave trail} other {are # cave trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'city-walk': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one city walk trail} other {are # city walk trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    dogs: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one dog-friendly trail} other {are # dog-friendly trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    forest: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one forest trail} other {are # forest trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'historic-site': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one historic site trail} other {are # historic site trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'hot-springs': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one trail with hot springs} other {are # trails with hot springs}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    kids: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one kid-friendly trail} other {are # kid-friendly trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    lake: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one lake trail} other {are # lake trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'partially-paved': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one partially paved trail} other {are # partially paved trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    paved: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one paved trail} other {are # paved trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'pub-crawl': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one pub walk} other {are # pub walks}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    'rails-trails': intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one rail trail} other {are # rail trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    river: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one river trail} other {are # river trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    strollers: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one stroller-friendly trail} other {are # stroller-friendly trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    waterfall: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one waterfall trail} other {are # waterfall trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    ),
    wildlife: intl.formatMessage(
      {
        defaultMessage: 'There {trailCount, plural, one {is one wildlife trail} other {are # wildlife trails}} in {parkName}. '
      },
      { trailCount, parkName, rating, reviewCount }
    )
  };

  const trailRatingTranslation = {
    default: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This trail has} other {These trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    backpacking: intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This backpacking trail has} other {These backpacking trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'bike-touring': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This bike touring trail has} other {These bike touring trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    birding: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This birding trail has} other {These birding trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    camping: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This camping trail has} other {These camping trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    fishing: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This fishing trail has} other {These fishing trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    hiking: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This hiking trail has} other {These hiking trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'horseback-riding': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This horseback riding trail has} other {These horseback riding trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'mountain-biking': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This mountain biking trail has} other {These mountain biking trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'off-road-driving': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This off-road driving trail has} other {These off-road driving trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'road-biking': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This road biking trail has} other {These road biking trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'rock-climbing': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This rock climbing trail has} other {These rock climbing trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'scenic-driving': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This scenic driving trail has} other {These scenic driving trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    skiing: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This skiing trail has} other {These skiing trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    snowshoeing: intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This snowshoeing trail has} other {These snowshoeing trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'trail-running': intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This running trail has} other {These running trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'via-ferrata': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This via ferrata trail has} other {These via ferrata trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    walking: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This walking trail has} other {These walking trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'cross-country-skiing': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This cross-country skiing trail has} other {These cross-country skiing trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    ada: intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This wheelchair-friendly trail has} other {These wheelchair-friendly trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    beach: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This beach trail has} other {These beach trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    cave: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This cave trail has} other {These cave trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'city-walk': intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This city walk trail has} other {These city walk trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    dogs: intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This dog-friendly trail has} other {These dog-friendly trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    forest: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This forest trail has} other {These forest trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'historic-site': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This historic site trail has} other {These historic site trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'hot-springs': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This trail with hot springs has} other {These trails with hot springs have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    kids: intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This kid-friendly trail has} other {These kid-friendly trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    lake: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This lake trail has} other {These lake trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'partially-paved': intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This partially paved trail has} other {These partially paved trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    paved: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This paved trail has} other {These paved trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'pub-crawl': intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This pub walk has} other {These pub walks have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    'rails-trails': intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This rail trail has} other {These rail trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    river: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This river trail has} other {These river trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    strollers: intl.formatMessage(
      {
        defaultMessage:
          '{trailCount, plural, one {This stroller-friendly trail has} other {These stroller-friendly trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    waterfall: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This waterfall trail has} other {These waterfall trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    ),
    wildlife: intl.formatMessage(
      {
        defaultMessage: '{trailCount, plural, one {This wildlife trail has} other {These wildlife trails have}} an average {rating}-star rating '
      },
      { trailCount, rating, reviewCount }
    )
  };

  const reviewsNumberTranslation = intl.formatMessage(
    {
      defaultMessage: 'from {reviewCount, number} AllTrails community {reviewCount, plural, one {review} other {reviews}}.'
    },
    { reviewCount }
  );

  return trailCountInLocationTranslation[messageKey] + trailRatingTranslation[messageKey] + reviewsNumberTranslation;
};
